import { Navigate } from 'react-router-dom'
import { Provider as UrqlProvider } from 'urql'
import { StoredCredentialsComponent } from 'app/components/stored-credentials/StoredCredentialsComponent'
import { opsClient } from 'app/lib/opsUrqlClient'
import { useUser } from 'app/utils'

export default function StoredCredentials(): React.ReactElement | null {
  const user = useUser()

  if (!user) return null

  // Super-user guard — must run before the data hook mounts so non-super users
  // never fire the super-only storedCredentials query (which returns Forbidden).
  if (user.type !== `super`) {
    return <Navigate to="/" replace />
  }

  // Stored credentials live entirely on the ops schema, so scope this subtree to
  // the ops urql client. Every useQuery/useMutation inside then targets
  // /graphql/ops natively instead of relying on per-call context overrides.
  return (
    <UrqlProvider value={opsClient}>
      <StoredCredentialsComponent />
    </UrqlProvider>
  )
}
